import React from 'react';
import useImage1 from '../../../assets/img/feed-imgs/center/homepost/user-propic1.png';
import useImage2 from '../../../assets/img/feed-imgs/center/homepost/user-propic2.png';
import postThumbnail1 from '../../../assets/img/feed-imgs/center/homepost/user-post1.png';
import postThumbnail2 from '../../../assets/img/feed-imgs/center/homepost/user-post2.png';
import heart from '../../../assets/img/feed-imgs/center/homepost/icons/post-heart.svg';
import comment from '../../../assets/img/feed-imgs/center/homepost/icons/post-comment.svg';
import plus from '../../../assets/img/feed-imgs/center/homepost/icons/post-plus.svg';
import share from '../../../assets/img/feed-imgs/center/homepost/icons/post-share.svg';

const ShowPosts = () => {
    const showAllPosts = [
        {
            userImage : useImage1,
            userName: "Rahim Philip",
            postTime: "5h ago",
            postDesc : "Ut tempus posuere eros et congue. Integer blandit lacus sapien, pulvinar venenatis lectus imperdiet in. Vivamus tempor magna a massa commodo, vitae rutrum odio pretium.",
            thambnailImage: postThumbnail1,
            postHeart: heart,
            postComment: comment,
            postPlus : plus,
            postShare: share
        },
        {
            userImage : useImage2,
            userName: "Rahim Philip",
            postTime: "5h ago",
            postDesc : "Ut tempus posuere eros et congue. Integer blandit lacus sapien, pulvinar venenatis lectus imperdiet in. Vivamus tempor magna a massa commodo, vitae rutrum odio pretium.",
            thambnailImage: postThumbnail2,
            postHeart: heart,
            postComment: comment,
            postPlus : plus,
            postShare: share
        }
    ]
    return (
        <div className="card w-auto mb-4" style={{backgroundColor: "transparent"}}>
            {
                showAllPosts.map(( item , index ) =><div className="card-body p-0" key={index}>
                     
                <div className="row mb-3">
                    <div className="col d-flex gap-3"><img src={item.userImage} alt="" />
                        <div className="d-grid"><span className="center_txt">{item.userName}</span><span className="time_txt">{item.postTime}</span></div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col"><span className="post_des">{item.postDesc}</span></div>
                </div>
                <div className="row mb-4">
                    <div className="col"><img className="w-100" src={item.thambnailImage}alt="" /></div>
                </div>
                <div className="d-flex justify-content-around align-items-center gap-2 ">
                    <div className='action-button d-flex'><img src={item.postHeart} alt="" /><span className="lc_as ms-1 ms-lg-3">259</span></div>
                    <div className='action-button d-flex'><img src={item.postComment} alt="" /><span className="lc_as ms-1 ms-lg-3">134</span></div>
                    <div className='action-button d-flex'><img src={item.postPlus} alt="" /><span className="lc_as ms-1 ms-lg-3">62</span></div>
                    <div className='action-button d-flex'><img src={item.postShare} alt="" /><span className="lc_as ms-1 ms-lg-3">25</span></div>
                </div>
                <div className="my-4" style={{height: "1px",background:" #707070"}}></div>
            </div>)
            }
        </div>
    );
};

export default ShowPosts;